import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Gallery() {
  const [activeFilter, setActiveFilter] = useState('전체');
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const filters = ['전체', '조경시설', '생활체육시설', '휴게시설', '기타'];
  
  const galleryItems = [
    {
      id: 1,
      title: '광명 현장 시공사례',
      category: '조경시설',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/13fe57878b1f1316abef6510c8fb565b.jpeg',
      description: 'A dreamy scrapbook page capturing the magic of Greek sunsets',
      images: [
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/9befee86a1cdc59891f49b1b71701fd7.jpeg',
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/26d2fa3dd9a5cff1e2bddce2614475b4.jpeg',
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/b4a5e96559e203e519a1e3b03eb8c309.jpeg'
      ]
    },
    {
      id: 2,
      title: 'Cherry Blossom Art Journal',
      category: '생활체육시설',
      image: 'https://public.readdy.ai/ai/img_res/ece86645d2871d2a08d4d62261b06cab.jpg',
      description: 'Mixed media art journal inspired by Japanese cherry blossoms',
      images: [
        'https://readdy.ai/api/search-image?query=Art%20journal%20spread%20with%20watercolor%20cherry%20blossoms%2C%20pink%20and%20white%20flowers%2C%20delicate%20brush%20strokes%2C%20handwritten%20poetry%2C%20mixed%20media%20elements%2C%20spring%20theme%2C%20soft%20pastel%20colors%2C%20artistic%20expression%2C%20creative%20journaling&width=800&height=600&seq=cherry-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Detailed%20view%20of%20cherry%20blossom%20watercolor%20painting%20in%20art%20journal%2C%20delicate%20pink%20petals%2C%20artistic%20brush%20techniques%2C%20handwritten%20Japanese%20poetry%2C%20spring-inspired%20colors&width=800&height=600&seq=cherry-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Cherry%20blossom%20art%20journal%20with%20pressed%20sakura%20petals%2C%20watercolor%20techniques%2C%20calligraphy%20elements%2C%20mixed%20media%20collage%2C%20Japanese%20aesthetic%20inspiration&width=800&height=600&seq=cherry-3&orientation=landscape'
      ]
    },
    {
      id: 3,
      title: 'Mountain Adventure Layout',
      category: '휴게시설',
      image: 'https://readdy.ai/api/search-image?query=Scrapbook%20layout%20with%20mountain%20hiking%20photos%2C%20adventure%20theme%2C%20outdoor%20elements%2C%20map%20backgrounds%2C%20compass%20decorations%2C%20nature-inspired%20colors%2C%20travel%20memories%2C%20creative%20photo%20arrangement%2C%20storytelling%20through%20design&width=400&height=500&seq=mountain-layout&orientation=portrait',
      description: 'Documenting an epic mountain hiking adventure',
      images: [
        'https://readdy.ai/api/search-image?query=Scrapbook%20layout%20with%20mountain%20hiking%20photos%2C%20adventure%20theme%2C%20outdoor%20elements%2C%20map%20backgrounds%2C%20compass%20decorations%2C%20nature-inspired%20colors%2C%20travel%20memories%2C%20creative%20photo%20arrangement%2C%20storytelling%20through%20design&width=800&height=600&seq=mountain-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Mountain%20adventure%20scrapbook%20with%20trail%20maps%2C%20hiking%20photos%2C%20elevation%20charts%2C%20camping%20memories%2C%20outdoor%20gear%20elements%2C%20rustic%20nature-themed%20design&width=800&height=600&seq=mountain-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Detailed%20mountain%20scrapbook%20page%20with%20panoramic%20landscape%20photos%2C%20handwritten%20trail%20notes%2C%20pressed%20leaves%2C%20adventure%20memorabilia%2C%20earthy%20color%20scheme&width=800&height=600&seq=mountain-3&orientation=landscape'
      ]
    },
    {
      id: 4,
      title: '부산 현장 시공사례',
      category: '기타',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/f57dfab9c648fdb494cd784cd17f36e6.png',
      description: 'Candid moments captured during city explorations',
      images: [
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/c911f4a6b1f59c0d6ca9f9a3025cce17.png',
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/28586d56234d6ae7d4ddfe9d8a40c39d.png',
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/6024f1433e05b5562772bfb8a95124dc.jpeg'
      ]
    },
    {
      id: 5,
      title: 'Handmade Wedding Album',
      category: '생활체육시설',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20handmade%20wedding%20album%20with%20lace%20details%2C%20vintage%20style%2C%20romantic%20photos%2C%20delicate%20embellishments%2C%20soft%20lighting%2C%20cream%20and%20gold%20colors%2C%20luxury%20craftsmanship%2C%20memory%20preservation%2C%20beautiful%20binding&width=400&height=500&seq=wedding-album&orientation=portrait',
      description: 'Custom wedding album with vintage lace details',
      images: [
        'https://readdy.ai/api/search-image?query=Elegant%20handmade%20wedding%20album%20with%20lace%20details%2C%20vintage%20style%2C%20romantic%20photos%2C%20delicate%20embellishments%2C%20soft%20lighting%2C%20cream%20and%20gold%20colors%2C%20luxury%20craftsmanship%2C%20memory%20preservation%2C%20beautiful%20binding&width=800&height=600&seq=wedding-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Wedding%20album%20pages%20with%20romantic%20lace%20borders%2C%20vintage%20wedding%20photos%2C%20delicate%20ribbon%20details%2C%20pearl%20embellishments%2C%20ivory%20and%20gold%20color%20scheme&width=800&height=600&seq=wedding-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Handcrafted%20wedding%20memory%20book%20with%20pressed%20flowers%2C%20vintage%20lace%2C%20romantic%20calligraphy%2C%20wedding%20memorabilia%2C%20elegant%20vintage%20aesthetic&width=800&height=600&seq=wedding-3&orientation=landscape'
      ]
    },
    {
      id: 6,
      title: '경주 현장 시공사례',
      category: '조경시설',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/e11420ec215f5349fe3a06f2b17ccfc3.png',
      description: 'Tropical memories from the beautiful island of Bali',
      images: [
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/34c06d0b15879569e8111f4683049d0f.png',
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/9a2975c1885e544fac3a3f8fc27bbeff.png',
        'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/74c63180cf29ffc1083e59c4af8d8d82.png'
      ]
    },
    {
      id: 7,
      title: 'Watercolor Landscape Series',
      category: '기타',
      image: 'https://readdy.ai/api/search-image?query=Series%20of%20landscape%20photographs%20with%20watercolor%20effects%2C%20dreamy%20nature%20scenes%2C%20soft%20colors%2C%20artistic%20processing%2C%20mountain%20lakes%2C%20forests%2C%20ethereal%20atmosphere%2C%20fine%20art%20photography%2C%20creative%20editing&width=400&height=500&seq=watercolor-landscapes&orientation=portrait',
      description: 'Landscape photography with watercolor effects',
      images: [
        'https://readdy.ai/api/search-image?query=Series%20of%20landscape%20photographs%20with%20watercolor%20effects%2C%20dreamy%20nature%20scenes%2C%20soft%20colors%2C%20artistic%20processing%2C%20mountain%20lakes%2C%20forests%2C%20ethereal%20atmosphere%2C%20fine%20art%20photography%2C%20creative%20editing&width=800&height=600&seq=watercolor-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Watercolor%20effect%20landscape%20photography%20showing%20misty%20mountains%2C%20soft%20ethereal%20colors%2C%20dreamy%20artistic%20processing%2C%20fine%20art%20nature%20photography&width=800&height=600&seq=watercolor-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Artistic%20landscape%20photography%20with%20watercolor%20treatment%2C%20forest%20scenes%2C%20soft%20pastel%20colors%2C%20ethereal%20atmosphere%2C%20creative%20photo%20manipulation&width=800&height=600&seq=watercolor-3&orientation=landscape'
      ]
    },
    {
      id: 8,
      title: 'Memory Box Project',
      category: '휴게시설',
      image: 'https://readdy.ai/api/search-image?query=Decorative%20memory%20box%20filled%20with%20photos%2C%20letters%2C%20small%20mementos%2C%20vintage%20style%2C%20nostalgic%20items%2C%20personal%20treasures%2C%20craft%20project%2C%20sentimental%20keepsakes%2C%20organized%20memory%20storage%2C%20handmade%20details&width=400&height=500&seq=memory-box&orientation=portrait',
      description: 'A treasure box filled with precious memories',
      images: [
        'https://readdy.ai/api/search-image?query=Decorative%20memory%20box%20filled%20with%20photos%2C%20letters%2C%20small%20mementos%2C%20vintage%20style%2C%20nostalgic%20items%2C%20personal%20treasures%2C%20craft%20project%2C%20sentimental%20keepsakes%2C%20organized%20memory%20storage%2C%20handmade%20details&width=800&height=600&seq=memory-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Vintage%20memory%20box%20contents%20with%20old%20photos%2C%20handwritten%20letters%2C%20ticket%20stubs%2C%20small%20keepsakes%2C%20nostalgic%20memorabilia%2C%20organized%20treasure%20collection&width=800&height=600&seq=memory-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Handmade%20memory%20storage%20box%20with%20compartments%2C%20vintage%20photos%2C%20personal%20mementos%2C%20decorative%20elements%2C%20sentimental%20keepsake%20organization&width=800&height=600&seq=memory-3&orientation=landscape'
      ]
    },
    {
      id: 9,
      title: 'Iceland Northern Lights',
      category: '조경시설',
      image: 'https://readdy.ai/api/search-image?query=Scrapbook%20page%20featuring%20Northern%20Lights%20photos%20from%20Iceland%2C%20aurora%20borealis%2C%20dramatic%20landscapes%2C%20dark%20sky%20with%20green%20lights%2C%20travel%20documentation%2C%20adventure%20theme%2C%20mystical%20atmosphere%2C%20creative%20layout%20design&width=400&height=500&seq=iceland-lights&orientation=portrait',
      description: 'Capturing the magical Northern Lights in Iceland',
      images: [
        'https://readdy.ai/api/search-image?query=Scrapbook%20page%20featuring%20Northern%20Lights%20photos%20from%20Iceland%2C%20aurora%20borealis%2C%20dramatic%20landscapes%2C%20dark%20sky%20with%20green%20lights%2C%20travel%20documentation%2C%20adventure%20theme%2C%20mystical%20atmosphere%2C%20creative%20layout%20design&width=800&height=600&seq=iceland-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Iceland%20Northern%20Lights%20travel%20journal%20with%20aurora%20photography%2C%20volcanic%20landscape%20photos%2C%20handwritten%20adventure%20notes%2C%20dark%20dramatic%20color%20scheme&width=800&height=600&seq=iceland-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Northern%20Lights%20scrapbook%20with%20Iceland%20landscape%20photos%2C%20aurora%20borealis%20images%2C%20travel%20memorabilia%2C%20mystical%20winter%20theme%2C%20dramatic%20lighting%20effects&width=800&height=600&seq=iceland-3&orientation=landscape'
      ]
    }
  ];
  
  const filteredItems = activeFilter === '전체' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeFilter);

  const handleCardClick = (itemId: number) => {
    setSelectedItem(itemId);
    setCurrentImageIndex(0);
  };

  const closePopup = () => {
    setSelectedItem(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (selectedItem !== null) {
      const item = galleryItems.find(item => item.id === selectedItem);
      if (item && currentImageIndex < item.images.length - 1) {
        setCurrentImageIndex(currentImageIndex + 1);
      }
    }
  };

  const prevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const goToImage = (index: number) => {
    setCurrentImageIndex(index);
  };

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const selectedGalleryItem = selectedItem ? galleryItems.find(item => item.id === selectedItem) : null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-20 md:pt-24 pb-10 md:pb-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-6xl font-bold text-gray-800 mb-4 md:mb-6">현장사진 갤러리</h1>
          <p className="text-base md:text-2xl text-gray-600 mb-6 md:mb-8 px-2">
            현장에서 완성되는 디자인과 기술을 결합을 확인할 수 있습니다.
          </p>
        </div>
      </section>
      
      {/* Filter Tabs */}
      <section className="pb-6 md:pb-8 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-2">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-4 md:px-6 py-1.5 md:py-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-base md:text-lg ${
                  activeFilter === filter
                    ? 'bg-emerald-500 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-emerald-100 shadow-md'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
      </section>
      
      {/* Gallery Grid */}
      <section className="pb-10 md:pb-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
            {filteredItems.map((item) => (
              <div 
                key={item.id}
                onClick={() => handleCardClick(item.id)}
                className="bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <div 
                    className="h-40 md:h-64 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                    style={{ backgroundImage: `url('${item.image}')` }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="absolute top-2 md:top-4 left-2 md:left-4">
                    <span className="bg-white/90 backdrop-blur-sm px-2 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-medium text-gray-700">
                      {item.category}
                    </span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center">
                      <i className="ri-eye-fill text-emerald-500 text-lg md:text-xl"></i>
                    </div>
                  </div>
                </div>
                <div className="p-3 md:p-6">
                  <h3 className="text-base md:text-2xl font-bold text-gray-800 mb-1 md:mb-2 line-clamp-1">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Popup */}
      {selectedItem && selectedGalleryItem && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-3 md:p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between p-4 md:p-6 border-b border-gray-100">
              <div className="flex-1 min-w-0 pr-4">
                <h3 className="text-lg md:text-2xl font-bold text-gray-800 truncate">{selectedGalleryItem.title}</h3>
              </div>
              <button
                onClick={closePopup}
                className="w-8 h-8 md:w-10 md:h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center cursor-pointer transition-colors flex-shrink-0"
              >
                <i className="ri-close-line text-gray-600 text-lg md:text-xl"></i>
              </button>
            </div>
            
            {/* Image Display */}
            <div className="relative">
              <div 
                className="w-full bg-cover bg-center"
                style={{ 
                  backgroundImage: `url('${selectedGalleryItem.images[currentImageIndex]}')`,
                  aspectRatio: '297 / 210'
                }}
              >
                {/* Navigation Arrows */}
                {currentImageIndex > 0 && (
                  <button
                    onClick={prevImage}
                    className="absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center cursor-pointer hover:bg-white transition-colors shadow-lg"
                  >
                    <i className="ri-arrow-left-line text-gray-800 text-lg md:text-xl"></i>
                  </button>
                )}
                
                {currentImageIndex < selectedGalleryItem.images.length - 1 && (
                  <button
                    onClick={nextImage}
                    className="absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center cursor-pointer hover:bg-white transition-colors shadow-lg"
                  >
                    <i className="ri-arrow-right-line text-gray-800 text-lg md:text-xl"></i>
                  </button>
                )}
                
                {/* Image Counter */}
                <div className="absolute top-3 md:top-4 right-3 md:right-4 bg-black/50 backdrop-blur-sm text-white px-2 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm">
                  {currentImageIndex + 1} / {selectedGalleryItem.images.length}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Featured Collection */}
      <section className="py-10 md:py-16 px-4 md:px-8 bg-gradient-to-r from-emerald-100 to-teal-100">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-8 md:mb-12">(주)그린디자인테크</h2>
          
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <h3 className="text-xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-6">
                "Standards for Eco-Friendly Space Solutions"
              </h3>
              <p className="text-sm md:text-lg text-gray-700 mb-4 md:mb-6 leading-relaxed">
                전 제작 과정에서 현장 조건과 목적에 맞춘<br />
                최적의 결과로 보여드리겠습니다.<br className="hidden md:block" />
                설계에서 현장까지<br />
                책임지는 그린디자인테크가 되겠습니다.
              </p>
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-center gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 bg-emerald-500 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-fill text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-sm md:text-base text-gray-700">경기도 김포시 대곶면 쇄암로 144&nbsp;</span>
                </div>
                <div className="flex items-center gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 bg-teal-500 rounded-full flex items-center justify-center">
                    <i className="ri-mail-fill text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-sm md:text-base text-gray-700">steng2021@naver.com</span>
                </div>
                <div className="flex items-center gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 bg-green-500 rounded-full flex items-center justify-center">
                    <i className="ri-phone-fill text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-sm md:text-base text-gray-700">031) 989-7136</span>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 order-1 md:order-2 h-56 md:h-[400px] bg-white"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/87ab45895326a83676b9038291f90bb1.png')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-gradient-to-r from-emerald-500 to-teal-500">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6">자연을 설계, 공간의 가치를 완성</h2>
          <p className="text-base md:text-xl mb-6 md:mb-8 leading-relaxed px-2">
            Harmony of Nature and Technology
          </p>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}
